import { toast } from "sonner";
import IconChooser from "./IconChooser";
import { LOCATION_ICONS, LocationIcon, iconKeyFor, useLocationIcons, autoIconKey } from "../lib/locations";

export function IconPicker({ name, children }) {
  const [map, update] = useLocationIcons();
  const cur = iconKeyFor(name, map);
  return (
    <IconChooser title={`Icon for ${name}`} subtitle={LOCATION_ICONS[cur]?.[1]} icons={LOCATION_ICONS} value={cur} testid="location-icon-picker"
      onPick={(k) => update(name, k === autoIconKey(name) ? null : k).catch(() => toast.error("Couldn't change the icon"))}>
      {children}
    </IconChooser>
  );
}

export const GRAVEYARD = "Graveyard";

export default function LocationGroups({ plants, renderCard, gridClass }) {
  const [map] = useLocationIcons();
  const groups = {};
  plants.forEach((p) => { const k = p.location?.trim() || ""; (groups[k] = groups[k] || []).push(p); });
  const rank = (n) => (n === GRAVEYARD ? 2 : n ? 0 : 1);
  const names = Object.keys(groups).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
  let idx = 0;
  return (
    <div className="space-y-12" data-testid="location-groups">
      {names.map((n) => (
        <section key={n || "none"} data-testid={`location-group-${n || "none"}`}>
          <div className="flex items-center gap-3 mb-5">
            {n === GRAVEYARD ? <span className="h-10 w-10 rounded-2xl bg-muted text-[#636366] inline-flex items-center justify-center" data-testid="location-group-icon-Graveyard"><LocationIcon name={n} map={map} className="h-5 w-5" /></span> : n ? (
              <IconPicker name={n}>
                <button type="button" aria-label={`Change icon for ${n}`} data-testid={`location-group-icon-${n}`}
                  className="h-10 w-10 rounded-2xl bg-primary/10 text-primary inline-flex items-center justify-center hover:bg-primary/15 active:scale-95 transition-[background-color,transform]">
                  <LocationIcon name={n} map={map} className="h-5 w-5" />
                </button>
              </IconPicker>
            ) : <span className="h-10 w-10 rounded-2xl bg-muted text-muted-foreground inline-flex items-center justify-center"><LocationIcon name="" className="h-5 w-5" /></span>}
            <h3 className={`text-lg font-semibold tracking-tight min-w-0 truncate ${n === GRAVEYARD ? "text-muted-foreground" : ""}`}>{n || "No location set"}</h3>
            <span className="text-sm text-muted-foreground tabular-nums">{groups[n].length}</span>
          </div>
          <div className={gridClass || "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"}>
            {groups[n].map((p) => renderCard(p, idx++))}
          </div>
        </section>
      ))}
    </div>
  );
}
